import { Action } from '@ngrx/store';

export enum QuantityActionTypes {
  QUANTITY_CHANGED = '[Quantity] Quantity changed',
  RESET = '[Quantity] Reset',
}

export class QuantityChangedAction implements Action {
  readonly type = QuantityActionTypes.QUANTITY_CHANGED;

  constructor(public payload: number) {}
}

export class QuantityResetAction implements Action {
  readonly type = QuantityActionTypes.RESET;

  constructor() {}
}

export type QuantityActions = QuantityChangedAction | QuantityResetAction;
